import React from 'react';
import { Outlet } from 'react-router-dom';

const AppNavigation = React.lazy(() => import('@/components/AppNavigation'));
const PublicDatasetsAppPage = React.lazy(
  () => import('@/containers/PublicDatasetsAppPage'),
);

const PUBLIC_DATASETS_PATHS = [
  '/publicdatasets/:datasourceId',
  '/publicdatasets/:datasourceId/:dataView',
  '/publicdatasets/:datasourceId/row-request/:rowRequestId',
  '/publicdatasets/:datasourceId/row-request/:rowRequestId/:dataView',
];

export default {
  path: 'publicdatasets',
  element: (
    <>
      <AppNavigation prefix="publicdatasets" />
      <Outlet />
    </>
  ),
  children: PUBLIC_DATASETS_PATHS.map((path) => ({
    path,
    element: <PublicDatasetsAppPage />,
  })),
};
